export class SocialMediaInstallationStatuses {
    apiTickets: boolean;
    appStore: boolean;
    appStoreTickets: boolean;
    chatTickets: boolean;
    emailTickets: boolean;
    facebook: boolean;
    facebookTickets: boolean;
    formTickets: boolean;
    googleMyBusiness: boolean;
    googleMyBusinessTickets: boolean;
    googlePlayMarket: boolean;
    googlePlayMarketTickets: boolean;
    instagram: boolean;
    instagramTickets: boolean;
    linkedin: boolean;
    linkedinTickets: boolean;
    tikTok: boolean;
    tikTokTickets: boolean;
    trustpilot: boolean;
    trustpilotTickets: boolean;
    voyadoCrm: boolean;
    whatsApp: boolean;
    whatsAppTickets: boolean;
    youtube: boolean;
    youtubeTickets: boolean;
}
